import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import DetailFormComponent from "../../../../components/Content/Complaint/DetailComplaint/DetailFormComponent";

interface IProps {
  getCodeTicket: any;
  getStatus: string;
  getNoTelp: any;
  getTitleComplaint: any;
}

class DetailFormContainer extends Component<IProps> {
  render() {
    
    return (
      <React.Fragment>
        <DetailFormComponent
          getCodeTicket={this.props.getCodeTicket}
          getStatus={this.props.getStatus}
          getNoTelp={this.props.getNoTelp}
          getTitleComplaint={this.props.getTitleComplaint}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state: any) => {

  return {
    getCodeTicket: state.Complaint.detailComplaint.codeTicket,
    getStatus: state.Complaint.detailComplaint.status,
    getNoTelp: state.Complaint.detailComplaint.phoneNumber,
    getTitleComplaint: state.Complaint.detailComplaint.titleComplaint,
  };
};
const mapDispatchToProps = (dispatch: any) => ({});
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(DetailFormContainer);
